import React from 'react';
import { Box, Container, Typography } from '@mui/material';

const TermsOfUsePage: React.FC = () => {
  return (
    <Box sx={{ width: '100%', background: '#F2F2F2' }}>
      <Container maxWidth={false} sx={{ maxWidth: '1100px', px: { xs: 2, sm: 3, md: 4 }, py: { xs: 6, sm: 8 } }}>
        <Typography sx={{ fontFamily: 'Inter', fontWeight: 800, fontSize: { xs: '28px', sm: '36px' }, color: '#1F1F1F', mb: 2 }}>
          Podmínky použití
        </Typography>
        <Typography sx={{ color: '#666', mb: 4 }}>Poslední aktualizace: {new Date().toLocaleDateString('cs-CZ')}</Typography>

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
          <Box>
            <Typography sx={{ fontWeight: 700, fontSize: '18px', mb: 1 }}>1. Obecně</Typography>
            <Typography sx={{ color: '#444' }}>
              Služba PravniBOT.cz poskytuje uživatelům obecné právní informace a nástroje pro práci s dokumenty. 
              Nejedná se o individuální právní poradenství ani právní zastoupení. Používáním služby souhlasíte s těmito podmínkami.
            </Typography>
          </Box>

          <Box>
            <Typography sx={{ fontWeight: 700, fontSize: '18px', mb: 1 }}>2. Charakter AI výstupů</Typography>
            <Typography sx={{ color: '#444' }}>
              Výstupy generované umělou inteligencí mohou obsahovat nepřesnosti a nemusí být vždy aktuální nebo úplné. 
              Jsou určeny pouze pro informační účely a nenahrazují odborné právní posouzení. 
              U závažných případů doporučujeme konzultaci s kvalifikovaným advokátem.
            </Typography>
          </Box>

          <Box>
            <Typography sx={{ fontWeight: 700, fontSize: '18px', mb: 1 }}>3. Odpovědnost uživatele</Typography>
            <Typography sx={{ color: '#444' }}>
              Uživatel nese odpovědnost za to, jak informace nebo dokumenty získané prostřednictvím služby použije. 
              Před jejich použitím by měl ověřit aktuálnost a vhodnost pro svůj konkrétní případ.
            </Typography>
          </Box>

          <Box>
            <Typography sx={{ fontWeight: 700, fontSize: '18px', mb: 1 }}>4. Omezení odpovědnosti</Typography>
            <Typography sx={{ color: '#444' }}>
              Provozovatel neodpovídá za škody způsobené použitím či nemožností použití služby, 
              zejména za škody plynoucí z rozhodnutí učiněných na základě AI výstupů. 
              Služba je poskytována „jak stojí a leží“ bez záruky úplnosti nebo bezchybnosti.
            </Typography>
          </Box>

          <Box>
            <Typography sx={{ fontWeight: 700, fontSize: '18px', mb: 1 }}>5. Přijatelné užití</Typography>
            <Typography sx={{ color: '#444' }}>
              Uživatel se zavazuje službu nezneužívat (např. k protiprávní činnosti, šíření škodlivého obsahu, 
              pokusům o narušení bezpečnosti či k automatizovanému sběru dat nad rámec běžného používání).
            </Typography>
          </Box>

          <Box>
            <Typography sx={{ fontWeight: 700, fontSize: '18px', mb: 1 }}>6. Změny podmínek</Typography>
            <Typography sx={{ color: '#444' }}>
              Provozovatel si vyhrazuje právo tyto podmínky kdykoli upravit. 
              Změny nabývají účinnosti zveřejněním. Doporučujeme průběžně kontrolovat aktuální znění.
            </Typography>
          </Box>

          <Box>
            <Typography sx={{ fontWeight: 700, fontSize: '18px', mb: 1 }}>7. Kontakt</Typography>
            <Typography sx={{ color: '#444' }}>
              Dotazy k podmínkám můžete adresovat na <a href="mailto:info@pravnibot.cz">info@pravnibot.cz</a>.
            </Typography>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default TermsOfUsePage;

